<script lang="ts">
  import Link from "svelte-link/src/Link.svelte";
  import { Card, CardFooter, CardHeader, Col, Image } from "sveltestrap";
  import ProfileData from "../../../Data/ComponentData/WidgetData/Genral/Profile.json";
  let imgPath : string= '/assets/images/avtar';
  let imagepath : string ="../assets/images/user-card"
  import { href } from "../../../utils/Constant/Constant";

</script>

<Col xl="4" md="6" class="box-col-6">
  <Card class="custom-card">
    <CardHeader>
      <Image fluid src="{imagepath}/3.jpg" alt="" />
    </CardHeader>
    <div class="card-profile">
      <Image class="rounded-circle" src="{imgPath}/3.jpg" alt="" />
    </div>
    <ul class="card-social">
      {#each ProfileData.icondata as iconItem}
        <li>
          <Link href={iconItem.href}><i class={iconItem.icon} /></Link>
        </li>
      {/each}
    </ul>
    <div class="text-center profile-details">
      <h4>
        <Link href={href} alt="">Scarlett john</Link>
      </h4>
      <h6>Manager</h6>
    </div>
    <CardFooter class="row">
      {#each ProfileData.profiledata as profileItem}
        <Col sm="4" xs="4" class="pb-0">
          <h6>{profileItem.title}</h6>
          <h3 class="counter">{profileItem.count}</h3>
        </Col>
      {/each}
    </CardFooter>
  </Card>
</Col>
